import React, { ReactElement } from "react";
import AdminList from "../../components/Admin";
import Layout from "../../components/layout";

const AdminPage = (): ReactElement => {
  return (
    <Layout>
      <AdminList />
    </Layout>
  );
};

export default AdminPage;
